import { configureBrowserSdk, createAppQueryClient } from '@repo/sdk'
import type { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { BackofficeNotFound, BackofficeRouteError } from '@/routes/__root'
import { routeTree } from './routeTree.gen'

export function getRouter() {
	const queryClient = createAppQueryClient()
	const router = createRouter({
		routeTree,
		context: { queryClient } satisfies RouterContext,
		defaultErrorComponent: BackofficeRouteError,
		defaultNotFoundComponent: BackofficeNotFound,
		defaultPreload: 'intent'
	})
	if (!router.isServer) {
		configureBrowserSdk({
			queryClient,
			getCsrfToken: (client) =>
				client.getQueryData<{ csrfToken: string | null }>([
					'auth',
					'session'
				])?.csrfToken,
			onUnauthorized: () => router.invalidate(),
			shouldSkipUnauthorizedRecovery: () => false
		})
	}
	return router
}

export interface RouterContext {
	queryClient: QueryClient
}

declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof getRouter>
	}
}
